import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-bets-and-picks.svg";
import * as styles from "./Icon.module.scss";

type BetsAndPicksProps = React.SVGProps<SVGSVGElement>;

export const BetsAndPicks = ({ className, ...props }: BetsAndPicksProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
